export default "__VITE_ASSET__DfVbH5$0__"